module.exports = __webpack_public_path__ + "static/media/chat03-3.093e5316.svg";